module.exports = __webpack_public_path__ + "img/shopping.12c0a78a.jpg";